import AssertionEntity from '../../lib/FormValidator/Assertion/AssertionEntity';
import AssertionItem from '../../lib/FormValidator/Assertion/AssertionItem';
import { PlanillaPartidoJugador } from '../PlanillaPartidoJugador/PlanillaPartidoJugador';
import { PlanillaPartido } from './PlanillaPartido';
export class PlanillaPartidoAssertions extends AssertionEntity {
  private constructor() {
    super();
  }

  static build() {
    const instance = new this();
    instance.addAssertionForDorsales();
    return instance;
  }

  addAssertionForDorsales(key = 'planilla_partido_jugador') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (planilla_partido_jugador) => {
          let ret = true;
          planilla_partido_jugador
            .filter((ppj: PlanillaPartidoJugador) => ppj.isActive() && ppj.getDorsal())
            .forEach((ppj: PlanillaPartidoJugador, idx1: number) => {
              planilla_partido_jugador
                .filter((ppj: PlanillaPartidoJugador) => ppj.isActive() && ppj.getDorsal())
                .forEach((ppj2: PlanillaPartidoJugador, idx2: number) => {
                  const hasRepeated =
                    idx1 !== idx2 &&
                    ppj2.isActive() &&
                    !!ppj2.getDorsal() &&
                    +ppj.getEqid() === +ppj2.getEqid() &&
                    +ppj.getDorsal() === +ppj2.getDorsal();
                  if (hasRepeated) {
                    ret = false;
                  }
                });
            });
          return ret;
        },
        key,
        'Los dorsales no se pueden repetir'
      )
    );
  }
}
